import { Button, Layout, Modal, Space, theme, Typography } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import { IoAddSharp } from "react-icons/io5";
import { Link, useParams } from "react-router-dom";
import routes from "../../../engine/routes";
import { clearInterpretes, getInterpretes } from "../Slices/InterpretesSlice";
import CustomTable from "../../../shared/components/CustomTable";
import {
  languagesList,
  renderUserFirstname,
  renderUserGenderShort,
  renderUserLanguagesLong,
  renderUserLastname,
  renderUserName,
  roles,
  subStatus,
} from "../../../utils/constants";
import { AiFillCalendar, AiFillFileExcel } from "react-icons/ai";
import { TbFileTypePdf, TbFileTypeXml, TbReportMoney } from "react-icons/tb";
import {
  createXMLString,
  createXMLWages,
  downloadStringFileXml_CSV,
  jsonToCsv,
} from "../../../utils/bills.xml";
import { http } from "../../../engine/api/http";
import { userHasLevel } from "../../../engine/AuthRoute";
import LogHistory from "../../../shared/components/LogHistory";
import { useTranslation } from "react-i18next";
import { customers } from "../../../engine/customerConfig";
import { InterpretesExportsExcel } from "./InterpretesExportsExcel";
import { FaUsers } from "react-icons/fa";
import i18n from "i18next";
import useDocumentCreator from "../../../engine/hooks/useDocumentCreator"; // Import useTranslation hook

const { Content, Sider, Header, Footer } = Layout;

export function InterpretesList(props) {
  const { interpretes, loading } = useSelector(state => state.interpretes);
  const dispatch = useDispatch();

  const { t } = useTranslation(); // Use useTranslation hook
  const formRef = useRef(null);
  const formRef2 = useRef(null);

  const [search, setSearch] = useState("");
  const [languageSearch, setLanguageSearch] = useState([]);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loadingExport, setLoading] = useState(false);

  const [get, createAndGet, isLoading, setUrl, doc] = useDocumentCreator();

  const onSelectChange = r => {
    setSelectedRowKeys(r);
  };

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  useEffect(() => {
    dispatch(getInterpretes());

    return () => {
      dispatch(clearInterpretes());
    };
  }, []);

  const columns = [
    {
      title: t("InterpretesList.columns.abacusId"),
      render: (a, record) => record.interpreteData.abacusId || "-",
      key: "f",
      sorter: (a, b, c) => {
        const getOrderWeight = item => {
          if (
            item.interpreteData.abacusId !== null &&
            item.interpreteData.abacusId !== undefined
          ) {
            return item.interpreteData.abacusId;
          } else {
            if (c === "ascend") {
              return 9999999999999999;
            } else {
              return -1; // Prioritize null or undefined
            }
          }
        };
        const idA = getOrderWeight(a);
        const idB = getOrderWeight(b);

        return idA - idB; // For ascending order (and default case)
      },
    },
    {
      title: t("InterpretesList.columns.lastname"),
      render: (n, record) => renderUserLastname(record),
      width: "15%",
      key: "nom",
      sorter: (a, b) => a.info.lastname.localeCompare(b.info.lastname),
    },
    {
      title: t("InterpretesList.columns.firstname"),
      render: (n, record) => renderUserFirstname(record),
      width: "15%",
      key: "Prénom",
      sorter: (a, b) => a.info.firstname.localeCompare(b.info.firstname),
    },
    {
      title: t("InterpretesList.columns.gender"),
      render: (n, record) => renderUserGenderShort(record),
      key: "Genre",
      width: 100,
      sorter: (a, b) => {
        const genreA = a?.info?.genre || "";
        const genreB = b?.info?.genre || "";
        return genreA.localeCompare(genreB);
      },
    },
    {
      title: t("InterpretesList.columns.email"),
      width: "25%",
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: t("InterpretesList.columns.languages"),
      render: (info, u) => renderUserLanguagesLong(u),
    },
    {
      title: t("InterpretesList.columns.access"),
      width: "15%",
      render: (status, u) => <span>{t(status)}</span>,
      dataIndex: "status",
      sorter: (a, b) => a.status.localeCompare(b.status),
    },
  ];

  const inputs = [
    {
      parentLabel: null,
      children: [
        {
          label: t("InterpretesList.inputs.searchLabel"),
          placeholder: t("InterpretesList.inputs.searchPlaceholder"),
          name: "search",
          value: "",
          type: "input",
          capitalize: false,
          col: 12,
        },
        {
          label: t("InterpretesList.inputs.filterLabel"),
          name: "langue",
          value: [],
          type: "dynamic-select",
          endPoint: "users/languages",
          showSearch: true,
          onChange: value => {
            setLanguageSearch(value);
          },
          itemCallback: item => {
            let trad = languagesList().find(e => e.value === item.value);
            return {
              key: item.value,
              label: `${trad ? trad.label : item.value}`,
              value: item.value,
            };
          },
          allowClear: true,
          reset: true,
          multiple: true,
          col: 12,
        },
      ],
    },
  ];

  const onValuesChange = changedValues => {
    Object.keys(changedValues).map(changed => {
      switch (changed) {
        case "search":
          setSearch(changedValues[changed]);
          break;
      }
    });
  };

  // const searchFilterData = () => {
  //   let copy = interpretes;
  //
  //   if (languageSearch.length > 0) {
  //     copy = copy.filter(interprete =>
  //         languageSearch.every(language =>
  //             interprete.interpreteData.languages.includes(language)
  //         )
  //     );
  //   }
  //
  //   if (search.length > 0) {
  //     const searchLowerCase = search.toLowerCase();
  //
  //     copy = copy.filter(interprete =>
  //         [
  //           interprete.info.firstname.toLowerCase(),
  //           interprete.email.toLowerCase(),
  //           interprete.interpreteData.address.toLowerCase(),
  //           interprete.interpreteData.addressStart.toLowerCase(),
  //           interprete.info.phone.toLowerCase(),
  //           interprete.info.lastname.toLowerCase()
  //         ].some(field => field.includes(searchLowerCase))
  //     );
  //   }
  //
  //   return copy;
  // };
  // Short function optimize by IA

  const searchFilterData = () =>
    interpretes.filter(interprete => {
      const { info, email, interpreteData } = interprete;
      const { firstname, lastname } = info;
      const { addressStart, languages, abacusId } = interpreteData;
      const searchLowerCase = search.toLowerCase();

      let hasLanguage =
        languageSearch.length === 0 ||
        languageSearch.some(language => languages.includes(language));

      const hasSearchMatch = [
        String(abacusId),
        firstname,
        lastname,
        email,
        addressStart,
      ].some(field => field?.toLowerCase()?.includes(searchLowerCase));

      return hasLanguage && (search.length === 0 || hasSearchMatch);
    });

  let copy2 = searchFilterData();

  const exportWagesXML = async () => {
    try {
      setLoading(true);

      // setShowModal(!showModal);

      const data = formRef.current.getFieldsValue(true);

      const loggit = await http.post("/logs", {
        baseUrl: "/api/users",
        action: "export",
        route: "/api/users/wages",
        ressource: "/api/users/wages",
        content: {
          interpreteIds: interpretes.map(e => e._id),
          ...data,
        },
      });

      const response = await http.post("bills/wages", {
        interpretes: interpretes.map(e => e._id),
        ...data,
      });

      const wages = response.data;

      switch (process.env.CUSTOMER_ID) {
        case customers.oseoavic:
          const xmlString = createXMLWages({
            wages,
            year: data.year,
            month: data.month,
          });

          downloadStringFileXml_CSV(
            xmlString,
            `salaires_${data.year}_${data.month}.xml`,
            "application/xml",
          );
        case customers.sosticino:
          const csvBlob = jsonToCsv(wages);

          downloadStringFileXml_CSV(
            csvBlob,
            `Nuovo_Template_MTFBS_import_${data.year}_${data.month}.csv`,
            "text/csv",
          );
      }

      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const exportWagesPdf = async () => {
    try {
      setLoading(true);

      // setShowModal(!showModal);

      const data = formRef.current.getFieldsValue(true);

      const loggit = await http.post("/logs", {
        baseUrl: "/api/users-pdf",
        action: "export",
        route: "/api/users/wages-pdf",
        ressource: "/api/users/wages-pdf",
        content: {
          interpreteIds: interpretes.map(e => e._id),
          ...data,
        },
      });

      const getPdf = () => {
        createAndGet(
          { interpretes: interpretes.map(e => e._id), ...data, language: i18n.language },
          `bills/wages-pdf`,
          true,
          true,
          () => {
            setLoading(false);
          },
          true,
          i18n.language === "fr"
            ? `salaire_${data.month}_${data.year}`
            : `stipendio_${data.month}_${data.year}`,
        );
      };

      getPdf();
    } catch (e) {
      console.log(e);
    }
  };

  const yearslabelsArray = () => {
    // add each year since 2023 and the current year by date
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 2023; i <= currentYear; i++) {
      years.push({ value: i, label: i });
    }
    return years;
  };

  const inputsModalDates = [
    {
      parentLabel: "",
      children: [
        {
          name: "year",
          label: t("InterpretesList.modal.year"),
          required: true,
          type: "select",
          value: new Date().getFullYear(),
          col: 24,
          selectContent: yearslabelsArray(),
        },
        {
          name: "month",
          col: 24,
          label: t("InterpretesList.modal.month"),
          type: "select",
          value: String(new Date().getMonth() + 1).padStart(2, "0"),
          required: true,
          selectContent: [
            { value: "01", label: t("InterpretesList.modal.january") },
            { value: "02", label: t("InterpretesList.modal.february") },
            { value: "03", label: t("InterpretesList.modal.march") },
            { value: "04", label: t("InterpretesList.modal.april") },
            { value: "05", label: t("InterpretesList.modal.may") },
            { value: "06", label: t("InterpretesList.modal.june") },
            { value: "07", label: t("InterpretesList.modal.july") },
            { value: "08", label: t("InterpretesList.modal.august") },
            { value: "09", label: t("InterpretesList.modal.september") },
            { value: "10", label: t("InterpretesList.modal.october") },
            { value: "11", label: t("InterpretesList.modal.november") },
            { value: "12", label: t("InterpretesList.modal.december") },
          ],
        },
      ],
    },
  ];

  const exportInterpretes = async () => {
    try {
      setLoading(true);

      let selected = copy2.filter(interprete =>
        selectedRowKeys.includes(interprete._id),
      );
      await InterpretesExportsExcel(selected);

      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Content>
      <LogHistory
        linkType={"detail"}
        route={"/api/users/wages"}
        label={t("InterpretesList.modal.recentSalaryExport")}
      />
      <Space
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={2} className={""}>
          {t("InterpretesList.other.interpreters")}
        </Typography.Title>

        <Space>
          <Link to={routes.interpretes("new").detail.path}>
            <Button
              size={"large"}
              type={"primary"}
              style={{
                justifySelf: "flex-start",
                display: "flex",
              }}
              icon={
                <IoAddSharp
                  style={{
                    marginTop: "0px",
                  }}
                  size={25}
                />
              }
            >
              {routes.interpretes().new.title}
            </Button>
          </Link>
          <Button
            disabled={loadingExport}
            loading={loadingExport}
            style={{
              justifySelf: "flex-start",
              display: "flex",
            }}
            size={"large"}
            onClick={() => setShowModal(!showModal)}
            icon={
              <TbReportMoney
                style={{
                  marginTop: "0px",
                }}
                size={25}
              />
            }
          >
            {t("InterpretesList.other.exportSalaries")}
          </Button>
          <Button
            disabled={selectedRowKeys.length === 0 || loadingExport}
            loading={loadingExport}
            style={{
              justifySelf: "flex-start",
              display: "flex",
            }}
            size={"large"}
            onClick={exportInterpretes}
            icon={
              <FaUsers
                style={{
                  marginTop: "0px",
                }}
                size={22}
              />
            }
          >
            {t("InterpretesList.other.exportInterpretes")}
          </Button>
        </Space>
      </Space>

      <CustomForm
        style={{
          flex: 1,
          maxWidth: 1200,
          paddingRight: 20,
        }}
        dataSource={inputs}
        labelCol={24}
        wrapperCol={24}
        refForm={formRef2}
        rowSelectedKeys={selectedRowKeys}
        onValuesChange={onValuesChange}
      />
      <CustomTable
        onSelectChange={onSelectChange}
        loading={loading}
        hasSelection={true}
        smTitle={item => {
          return (
            <div className={"alignHeaderPage"}>
              <h2 className={"noMargin"}>{renderUserName(item)}</h2>
            </div>
          );
        }}
        onRowLink={record => routes.interpretes(record._id).detail.path}
        hasPagination={true}
        pagination={{
          hideOnSinglePage: true,
          position: ["topRight"],
          defaultPageSize: 100,
          pageSizeOptions: [10, 20, 50, 100],
          showSizeChanger: true,
        }}
        dataSource={copy2}
        columns={columns}
        rowKey="_id"
      />
      <Modal
        open={showModal}
        title={t("InterpretesList.modal.selectPeriod", {
          n: interpretes.length,
        })}
        okButtonProps={{ loading: loadingExport }}
        width={800}
        footer={[
          <Button
            key="back"
            onClick={() => setShowModal(!showModal)}
            loading={loadingExport}
          >
            {t("routes.back")}
          </Button>,
          <Button
            key="xml"
            onClick={exportWagesXML}
            type={"primary"}
            loading={loadingExport}
          >
            <Space>
              <TbFileTypeXml size={18} />
              {t("InterpretesList.modal.exportSalaries")} XML
            </Space>
          </Button>,
          <Button
            key="pdf"
            onClick={exportWagesPdf}
            type={"primary"}
            loading={loadingExport}
          >
            <Space>
              <TbFileTypePdf size={18} />
              {t("InterpretesList.modal.exportSalaries")} PDF
            </Space>
          </Button>,
        ]}
      >
        <CustomForm
          dataSource={inputsModalDates}
          refForm={formRef}
          style={{
            flex: 1,
            maxWidth: 1200,
            paddingRight: 20,
          }}
          labelCol={24}
          wrapperCol={24}
        />
      </Modal>
    </Content>
  );
}
